module.exports = __webpack_public_path__ + "img/image_41.a89d5dcb.png";